import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { List, X, SignOut, User as UserIcon } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { motion, AnimatePresence } from "framer-motion";

const Header = () => {
  const { user, authUser, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { to: "/actividades?category=yoga", label: "Yoga" },
    { to: "/actividades?category=pilates", label: "Pilates" },
    { to: "/actividades?category=fisioterapia", label: "Fisio" },
    { to: "/actividades", label: "Todas" },
  ];

  const handleLogout = async () => { await logout(); navigate("/"); };
  const role = user?.role;

  return (
    <header className="sticky top-0 z-50 glass border-b border-forest/10" data-testid="site-header">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
            <img src="/slotfy-logo.jpg" alt="Slotfy" className="w-9 h-9 md:w-10 md:h-10 rounded-lg object-cover ring-1 ring-forest/10" />
            <span className="font-heading text-2xl md:text-3xl font-semibold text-forest tracking-tight">Slotfy</span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((n) => (
              <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`}
                className={`text-[13px] uppercase tracking-[0.2em] font-medium transition hover:text-sage-deep ${
                  location.pathname + location.search === n.to ? "text-sage-deep" : "text-stone"
                }`}>{n.label}</Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            {authUser ? (
              <>
                {role === "superadmin" && (
                  <Link to="/super-admin" data-testid="nav-super-admin" className="text-xs uppercase tracking-[0.2em] text-stone hover:text-sage-deep transition">Super</Link>
                )}
                {(role === "admin" || role === "superadmin") && (
                  <Link to="/admin" data-testid="nav-admin" className="text-xs uppercase tracking-[0.2em] text-stone hover:text-sage-deep transition">Admin</Link>
                )}
                <Link to="/dashboard" data-testid="nav-dashboard" className="flex items-center gap-2 px-4 py-2 border border-forest/15 hover:bg-mist transition rounded-full">
                  <UserIcon size={16} />
                  <span className="text-sm">{(authUser.user_metadata?.full_name || authUser.email || "").split(" ")[0]}</span>
                </Link>
                <button onClick={handleLogout} data-testid="logout-btn" className="p-2 hover:bg-mist transition rounded-full" title="Cerrar sesión">
                  <SignOut size={18} />
                </button>
              </>
            ) : (
              <>
                <Link to="/login" data-testid="header-login-btn" className="text-sm uppercase tracking-[0.2em] text-stone hover:text-forest transition">Entrar</Link>
                <Link to="/registro" data-testid="header-register-btn"
                  className="bg-sage-deep text-paper px-5 py-2.5 font-medium text-sm tracking-wide hover:bg-forest transition rounded-full">Crear cuenta</Link>
              </>
            )}
          </div>

          <button onClick={() => setOpen(!open)} className="md:hidden p-2" data-testid="mobile-menu-btn">
            {open ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
            className="md:hidden border-t border-forest/10 overflow-hidden bg-paper">
            <div className="px-6 py-4 space-y-3">
              {navItems.map((n) => (
                <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="block py-2 text-sm uppercase tracking-[0.2em] text-stone hover:text-sage-deep">{n.label}</Link>
              ))}
              <div className="pt-3 border-t border-forest/10 space-y-2">
                {authUser ? (
                  <>
                    <Link onClick={() => setOpen(false)} to="/dashboard" className="block py-2">Mi cuenta</Link>
                    {(role === "admin" || role === "superadmin") && <Link onClick={() => setOpen(false)} to="/admin" className="block py-2">Admin</Link>}
                    {role === "superadmin" && <Link onClick={() => setOpen(false)} to="/super-admin" className="block py-2">Super Admin</Link>}
                    <button onClick={() => { setOpen(false); handleLogout(); }} className="block py-2 text-red-500">Cerrar sesión</button>
                  </>
                ) : (
                  <>
                    <Link onClick={() => setOpen(false)} to="/login" className="block py-2">Entrar</Link>
                    <Link onClick={() => setOpen(false)} to="/registro" className="block py-2 text-sage-deep font-semibold">Crear cuenta</Link>
                  </>
                )}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
